import { SYSTEM_COLORS } from "./themeConstants";

export const cardLayoutStyles = {
  container: (borderColor) => ({
    background: SYSTEM_COLORS.white,
    borderRadius: "16px",
    marginBottom: "20px",
    width: "100%",
    boxShadow: "0 10px 15px -3px rgba(0,0,0,0.07)",
    border: `2px solid ${borderColor}`,
    overflow: "hidden",
    minHeight: "100px",
    display: "flex",
    flexDirection: "column",
  }),
  header: (bgColor, borderColor) => ({
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 15px",
    background: bgColor,
    borderBottom: `1px solid ${borderColor}${SYSTEM_COLORS.borderOpacity}`,
  }),
  body: {
    padding: "15px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  badge: (config) => ({
    background: config.bg,
    color: config.color,
    padding: "5px 15px",
    borderRadius: "8px",
    fontSize: "0.75rem",
    textAlign: "center",
    fontWeight: "900",
    border: `1px solid ${config.color}${SYSTEM_COLORS.borderOpacity}`,
    flex: 1,
  }),
  tag: {
    fontSize: "0.65rem",
    background: SYSTEM_COLORS.light,
    padding: "2px 8px",
    borderRadius: "6px",
    color: SYSTEM_COLORS.muted,
    border: `1px solid ${SYSTEM_COLORS.tableBorder}`,
  },
};

export const tableLayoutStyles = {
  stickyColumn: {
    backgroundColor: SYSTEM_COLORS.tableStickyBg,
    color: SYSTEM_COLORS.primaryDark,
    borderRight: `2px solid ${SYSTEM_COLORS.tableStickyBorder}`,
    borderBottom: `1px solid ${SYSTEM_COLORS.tableStickyBorder}`,
    width: "220px",
    zIndex: 10,
    position: "sticky",
    left: 0,
  },
  filterBar: {
    borderRadius: "16px",
    border: `1px solid ${SYSTEM_COLORS.tableBorder}`,
    padding: "16px",
    backgroundColor: SYSTEM_COLORS.white,
    display: "flex",
  },
  partitionButton: (isActive) => ({
    flex: 1,
    minWidth: "180px",
    borderRadius: "10px",
    backgroundColor: isActive
      ? `${SYSTEM_COLORS.white} !important`
      : "transparent !important",
    color: isActive
      ? `${SYSTEM_COLORS.primary} !important`
      : SYSTEM_COLORS.muted,
    boxShadow: isActive ? "0 4px 6px -1px rgba(0,0,0,0.1)" : "none",
  }),
  actionButton: (isDisabled) => ({
    background: "rgba(255, 255, 255, 0.6)",
    border: `1px solid ${SYSTEM_COLORS.danger}${SYSTEM_COLORS.borderOpacity}`,
    borderRadius: "8px",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: isDisabled ? SYSTEM_COLORS.secondary : SYSTEM_COLORS.danger,
    cursor: isDisabled ? "not-allowed" : "pointer",
  }),
};
